import ExitToApp from '@mui/icons-material/ExitToApp';

import { GRAPH_LEGEND_ICON_SIZE as iconSize } from 'common/constants';
import ELEMENT from 'common/element';

import './SelectionDeltas.scss';

type SelectionDeltasProps = {
  selectionDeltas: Record<string, string>;
  testId?:         ELEMENT;
};

/**
 * SelectionDeltas are different delta values from the graph selection
 *
 * @prop selectionDeltas
 * @prop testId
 */
function SelectionDeltas({
  selectionDeltas,
  testId,
}: SelectionDeltasProps): JSX.Element {

  return (
    <div className="SelectionDeltas">
      <div className="SelectionDeltas__title" data-test-id={testId}>Selection Deltas</div>
      <p className="SelectionDeltas__hint">(calculated across range selection)</p>
      { Object.keys(selectionDeltas).map((label) => (
        <div className="SelectionDeltas__row" key={label}>
          <div className="SelectionDeltas__labelContainer">
            <ExitToApp style={{ fontSize: iconSize }} />
            <div className="SelectionDeltas__label">
              {label}
            </div>
          </div>
          <div>
            {selectionDeltas[label]}
          </div>
        </div>
      ))}
    </div>
  );
}

export default SelectionDeltas;
